module.exports = __webpack_public_path__ + "img/104084.f33eec27.png";